import { render } from "./manual-transfer-popup.vue?vue&type=template&id=dabfcaaa&scoped=true&ts=true"
import script from "./manual-transfer-popup.vue?vue&type=script&lang=ts"
export * from "./manual-transfer-popup.vue?vue&type=script&lang=ts"

import "./manual-transfer-popup.vue?vue&type=style&index=0&id=dabfcaaa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dabfcaaa"]])

export default __exports__